import React, { useEffect } from 'react';

/**
 * ImagePreloader component for preloading critical images
 */
const ImagePreloader = ({ images = [] }) => {
  useEffect(() => {
    const preloadImages = (imageUrls) => {
      imageUrls.forEach((url) => {
        if (url && !url.startsWith('data:')) { // Skip data URLs
          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'image';
          link.href = url;
          // Same-origin images: omit crossOrigin to match default <img> credentials mode
          if (/^https?:\/\//i.test(url) && !url.includes(window.location.origin)) {
            link.crossOrigin = 'anonymous';
          }
          link.fetchPriority = 'high';
          document.head.appendChild(link);
        }
      });
    };

    // Preload critical images
    preloadImages(images);

    // Cleanup function
    return () => {
      const preloadLinks = document.querySelectorAll('link[rel="preload"][as="image"]');
      preloadLinks.forEach((link) => {
        if (images.includes(link.href)) {
          document.head.removeChild(link);
        }
      });
    };
  }, [images]);

  return null; // This component doesn't render anything
};

export default ImagePreloader;
